import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';

import {
  FormConfig,
  FormField,
  IFormComponent,
  IFormConfig,
  IFormField,
} from '@models/form/form';
import { ISelectField, SelectField } from '@models/form/select';

@Component({
  selector: 'app-form-select',
  templateUrl: './form-select.component.html',
  styleUrls: ['./form-select.component.scss'],
  // TODO: This is set to the default change detection for now to show validation messages correctly. Switch back when possible.
  changeDetection: ChangeDetectionStrategy.Default,
})
export class FormSelectComponent implements IFormComponent<ISelectField> {
  public config: IFormField<ISelectField> = new FormField<ISelectField>({
    fieldConfig: new SelectField(),
  });
  public formConfig: IFormConfig = new FormConfig();
  public group: UntypedFormGroup = new UntypedFormGroup({});

  public get formControl(): AbstractControl {
    return this.group.get(this.config.name);
  }
}
